import { type TFunction } from 'i18next';

export const label = (t: TFunction, key: string) => t(`taxpayer-request.label.${key}`);
export const validations = (t: TFunction, key: string) => t(`taxpayer-request.validations.${key}`);
export const labelVector = (t: TFunction, key: string) => t(`taxpayer-request.vector.label.${key}`);
